

















import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ShortDecimalInput extends Vue {

  @Prop() disabled!: boolean;
  @Prop() label!: string;
  @Prop({ default: 3 }) places!: number;
  @Prop() readonly!: boolean;
  @Prop() required!: boolean;
  @Prop() suffix!: string;
  @Prop() value!: number | null;

  @Emit('focus') emitFocus() { }
  @Emit('submit') emitSubmit() { }

  localValue = this.value === null ? '' : '' + this.value;
  prevValue = this.localValue;

  get digitFormat() {
    return new RegExp(`\^\\d*\\.?\\d{0,${this.places}}\$`);
  }

  @Watch('localValue') watchLocalValue(newValue: string/*, oldValue: string*/) {
    if (newValue.match(this.digitFormat)) {
      this.prevValue = this.localValue;
      this.localValue = newValue;

      const valueAsNumber = parseFloat(this.localValue);
      this.$emit('input', isNaN(valueAsNumber) ? null : valueAsNumber);
    }
    else {
      setTimeout(() => {
        this.localValue = this.prevValue || '';
      });
    }
  }

  focus() {
    const vTextField = this.$refs.vTextField as any;  //as VTextField;
    vTextField.focus();
    vTextField.$refs.input.select();
  }

}
